module.exports = __webpack_public_path__ + "portal/static/img/aomsin.bb2375e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-bank/aomsin.png
// module id = U4Uz
// module chunks = 67